// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"a7580c82","899":"3179c0a7"}[chunkId] + ".chunk.js";
};